import { CoveoSearchBox as SearchBox } from "@dcl-ue/coveo-search";
var CoveoSearchBox = SearchBox.template;
CoveoSearchBox.displayName = "CoveoSearchBox";
export default CoveoSearchBox;